<template>
   <div class="update_pwd_mask"  v-if="updatePwdShow">
    <el-card class="update_pwd">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">修改密码</span>
        </div>
        <el-form :label-position="labelPosition" :rules="rules" label-width="80px" :model="fromUpdatePwd" ref="fromUpdatePwd">
            <el-form-item label="登录密码"  prop="password">
                <el-input type="password" v-model="fromUpdatePwd.password" placeholder="请输入登录密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码"  prop="pwdAgain">
                <el-input type="password" v-model="fromUpdatePwd.pwdAgain" placeholder="请确认登录密码"></el-input>
            </el-form-item>
             <el-form-item>
                <el-button style="width:40%;" @click="resetForm('fromUpdatePwd')">重置</el-button>
                <el-button style="width:40%" type="primary" @click="submitForm('fromUpdatePwd')" :loading="loading">提交</el-button>
            </el-form-item>
        </el-form>
        <span @click="boxColose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
    </el-card>
    </div>
</template>
<script>
    import $axios from '../../https/config'
    import md5 from 'js-md5'
    export default {
      props: ['updatePwdShow', 'theId'],
      data () {
        var validatePass2 = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请再次输入密码'))
          } else if (value !== this.fromUpdatePwd.password) {
            callback(new Error('两次输入密码不一致!'))
          } else {
            callback()
          }
        }
        return {
          labelPosition: 'right',
          addShowOk: this.addShow,
          loading: false,
          fromUpdatePwd: {
            password: '',
            pwdAgain: ''
          },
          rules: {
            password: [
              {required: true, message: '请输入密码', trigger: 'blur'},
              { min: 6, max: 12, message: '密码长度在 6 到 12 个字符', trigger: 'blur' }
            ],
            pwdAgain: [
              {validator: validatePass2, trigger: 'blur'}
            ]
          }
        }
      },
      computed: {
        updatePwdOk: function () {
          return this.updatePwdShow
        }
      },
      methods: {
        boxColose () {
          this.$emit('closeUpdatePwd', false)
        },
        submitForm (formData) {
          this.$refs.fromUpdatePwd.validate((valid) => {
            if (valid) {
              this.loading = true
              var _this = this
              var params = {
                id: this.theId,
                password: md5(this.fromUpdatePwd.password)
              }
              var url = '/custom/changePwd'
              $axios.post(url, params, 'headers', function (res) {
                _this.loading = false
                if (res.resultStatus) {
                  _this.$message({
                    message: '修改密码成功！',
                    type: 'success'
                  })
                  _this.resetForm()
                  _this.$emit('closeUpdatePwd', false)
                } else {
                  _this.$message({
                    message: '修改密码失败' + res.errorMessage,
                    type: 'error'
                  })
                }
              }, function (err) {
                _this.loading = false
                _this.$message({
                  type: 'error',
                  duration: 1000 * 5,
                  message: '服务器异常，请稍后再试!' + err
                })
              })
            } else {
              _this.$message({
                type: 'error',
                duration: 1000 * 5,
                message: '请检查填写的数据!'
              })
              return false
            }
          })
        },
        resetForm (formData) {
          this.$refs.fromUpdatePwd.resetFields()
        }

      }
    }
</script>
<style lang="scss">
  .update_pwd_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      .update_pwd {
          width: 400px;
          top: 20%;
          left: 50%;
          z-index: 101;
          margin-left: -200px;
          position: fixed;

          .el-card__header {
              padding: 10px
          }
          .el-card__body {
              padding: 20px 40px;
              .el-form-item {
                  width: 90%
              }
          }
      }
  }
</style> 


// WEBPACK FOOTER //
// src/page/accountMgr/updatePwd.vue